var map = {
	"./StarRocks.jpg": "./src/assets/datasource/StarRocks.jpg",
	"./TiDB.jpg": "./src/assets/datasource/TiDB.jpg",
	"./api.jpg": "./src/assets/datasource/api.jpg",
	"./ck.jpg": "./src/assets/datasource/ck.jpg",
	"./db2.jpg": "./src/assets/datasource/db2.jpg",
	"./ds_doris.jpg": "./src/assets/datasource/ds_doris.jpg",
	"./es.jpg": "./src/assets/datasource/es.jpg",
	"./hive.jpg": "./src/assets/datasource/hive.jpg",
	"./impala.jpg": "./src/assets/datasource/impala.jpg",
	"./mariadb.jpg": "./src/assets/datasource/mariadb.jpg",
	"./mongo.jpg": "./src/assets/datasource/mongo.jpg",
	"./mysql.jpg": "./src/assets/datasource/mysql.jpg",
	"./oracle.jpg": "./src/assets/datasource/oracle.jpg",
	"./pg.jpg": "./src/assets/datasource/pg.jpg",
	"./redshift.jpg": "./src/assets/datasource/redshift.jpg",
	"./sqlServer.jpg": "./src/assets/datasource/sqlServer.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/datasource sync recursive ^\\.\\/.*\\.jpg$";